import { Toolbar } from '@mui/material';
import Box from '@mui/material/Box';
import { useRecoilValue } from 'recoil';
import { explorerSidebarOpenState } from '~/state/atoms/viewerAtoms';
import Sidebar from '../../../components/Sidebar';
import Dataset from './Dataset';
import Doses from './Doses';
import Images from './Images';
import Structures from './Structures';

const sections = [Dataset, Images, Doses, Structures];

export default function ExplorerSidebar() {
    const sidebarOpen = useRecoilValue(explorerSidebarOpenState);
    return (
        <Sidebar side="left" open={sidebarOpen}>
            <Box display="flex" flexDirection="column" height="100%">
                <Toolbar variant="dense" />
                <Box
                    rowGap={2}
                    paddingY={2}
                    display="flex"
                    flexDirection="column"
                    height="100%"
                >
                    {sections.map((Section, index) => (
                        <Section key={index} />
                    ))}
                </Box>
            </Box>
        </Sidebar>
    );
}
